import LegalLayout, { LEGAL } from "./LegalLayout";
import { openCookieSettings } from "../../lib/consent";

// EDIT HERE — cookie inventory; keep in sync with what the site actually sets
const COOKIES = [
  { name: "access_token", type: "Strictly necessary", purpose: "Keeps you signed in to the OrthoPlaniX portal (HttpOnly, secure).", duration: "12 hours" },
  { name: "opx_cookie_consent", type: "Strictly necessary", purpose: "Remembers your cookie choices (stored in local storage).", duration: "12 months / until cleared" },
  { name: "__emg_vid, __emg_sid", type: "Strictly necessary", purpose: "Set by our hosting edge for security, traffic management and abuse prevention.", duration: "Session – 12 months" },
  { name: "__cf_bm", type: "Strictly necessary", purpose: "Cloudflare bot protection for the website.", duration: "30 minutes" },
  { name: "ph_*", type: "Analytics (consent)", purpose: "PostHog analytics — anonymous usage statistics and session diagnostics. Only set after you accept analytics.", duration: "Up to 12 months" },
];

const SECTIONS = [
  { h: "What cookies are", p: [
    "Cookies are small text files placed on your device by a website. Similar technologies include local storage and pixels. We use them to keep you signed in, remember your preferences and — only with your consent — understand how the website is used.",
  ]},
  { h: "How we ask for consent", p: [
    "When you first visit, a banner lets you accept all cookies, reject non-essential cookies, or manage categories individually. Non-essential cookies are not set until you opt in. We honour the Global Privacy Control (GPC) browser signal as an opt-out of analytics.",
    "You can change or withdraw your choice at any time using the button below or the “Cookie settings” link in the footer.",
  ]},
  { h: "Cookies we use", p: [
    <div className="overflow-x-auto -mx-2">
      <table className="min-w-full text-xs" data-testid="cookie-table">
        <thead>
          <tr className="text-left text-slate-500 uppercase tracking-widest text-[10px]">
            <th className="px-2 py-2">Name</th><th className="px-2 py-2">Category</th><th className="px-2 py-2">Purpose</th><th className="px-2 py-2">Duration</th>
          </tr>
        </thead>
        <tbody>
          {COOKIES.map((c) => (
            <tr key={c.name} className="border-t border-white/10 align-top">
              <td className="px-2 py-3 font-mono text-neon whitespace-nowrap">{c.name}</td>
              <td className="px-2 py-3 whitespace-nowrap">{c.type}</td>
              <td className="px-2 py-3">{c.purpose}</td>
              <td className="px-2 py-3 whitespace-nowrap">{c.duration}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>,
  ]},
  { h: "Third-party services", p: [
    "Analytics is provided by PostHog and only activates after consent. If you pay an invoice online, Razorpay or PayPal may set their own cookies on their checkout pages under their own policies. If you sign in with Google, Google sets cookies under its policy.",
  ]},
  { h: "Managing cookies in your browser", p: [
    "You can also block or delete cookies through your browser settings. Blocking strictly necessary cookies will prevent you from signing in to the portal.",
  ]},
  { h: "Contact", p: [`Questions about cookies: ${LEGAL.email}. See also our Privacy Policy.`] },
];

export default function Cookies() {
  return (
    <LegalLayout tag="Cookie Policy" title="Cookies," accent="clearly explained." sections={SECTIONS}
      intro="Which cookies OrthoPlaniX uses, why, and how you stay in control.">
      <div className="border-t border-white/10 pt-8">
        <button onClick={openCookieSettings} data-testid="cookie-policy-settings-btn"
          className="rounded-full bg-neon px-6 py-3 text-sm font-bold text-ink transition-transform duration-300 hover:scale-105">
          Manage cookie settings
        </button>
      </div>
    </LegalLayout>
  );
}
